export default __webpack_public_path__ + "static/media/help.905cb090.svg";